import { StyledPropType } from 'style-utils/core/core.types';
import { createExtractCssFromProps } from 'style-utils/core/createExtractCssFromProps/createExtractCssFromProps';
import { CSSProperties } from 'styled-components';

const shadowMappedProps = {
  boxShadow: {
    property: 'boxShadow',
  },
  textShadow: {
    property: 'textShadow',
  },
};

export type WithShadowProps = {
  boxShadow?: StyledPropType<CSSProperties['boxShadow']>;
  textShadow?: StyledPropType<CSSProperties['textShadow']>;
};

export const withShadow = createExtractCssFromProps(shadowMappedProps);
